export default __webpack_public_path__ + "static/media/aw.1a955653.svg";